import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const ImageInsertButton = () => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { ZwibblerUseImageTool, isZoomed } = rootStore.zwibblerStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleClick = () => {
    ZwibblerUseImageTool();
  };

  return (
    <>
      <Button
        id="image"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 toolbarButton transparentButton",
          `${theme!.toolbarIconColor}`
        )}
        disabled={isZoomed}
        color=""
        onClick={() => handleClick()}
        style={{ position: "relative" }}
      >
        <i className="fas fa-image iconToolbarButton"></i>

        <h6 className="textToolbarButton mb-0 labelButtonHeight">
          {t("toolbar_insert_image_button")}
        </h6>
      </Button>
    </>
  );
};

export default observer(ImageInsertButton);
